import React from 'react';
import Icon from '../../../components/AppIcon';

const ExecutiveSummaryCard = ({ title, value, subtitle, icon, status }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'compliant':
        return {
          bg: 'bg-success/10',
          text: 'text-success',
          border: 'border-success/20'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          text: 'text-warning',
          border: 'border-warning/20'
        };
      case 'critical':
        return {
          bg: 'bg-error/10',
          text: 'text-error',
          border: 'border-error/20'
        };
      case 'info':
        return {
          bg: 'bg-primary/10',
          text: 'text-primary',
          border: 'border-primary/20'
        };
      default:
        return {
          bg: 'bg-muted',
          text: 'text-foreground',
          border: 'border-border'
        };
    }
  };

  const styles = getStatusStyles();

  return (
    <div className={`bg-card border ${styles?.border} rounded-lg p-6 transition-smooth hover:shadow-md`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`${styles?.bg} ${styles?.text} p-3 rounded-md`}>
          <Icon name={icon} size={20} color="currentColor" />
        </div>
      </div>
      <h3 className="text-sm text-muted-foreground mb-2">{title}</h3>
      <div className="flex items-baseline gap-2 mb-1">
        <span className={`text-3xl font-bold ${styles?.text}`}>
          {value}
        </span>
      </div>
      {subtitle && (
        <p className="text-xs text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default ExecutiveSummaryCard;